import apiClient from './client';

export const SpecialtyAxiosInstance = apiClient;